import React from 'react';
import { AwarenessTemplate } from '../components/training/templates/AwarenessTemplate';
import { getStandardBySlug } from '../data/standards/standardsData';
import { getAwarenessContent } from '../data/standards/trainingContent';

export const ISO21001Awareness = () => {
  const standard = getStandardBySlug('iso-21001');
  const content = getAwarenessContent('iso-21001');

  return <AwarenessTemplate standard={standard} content={content} />;
};
